"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../../../errors");
const ICondition_1 = require("../../models/rates/ICondition");
const Default_1 = __importDefault(require("./Default"));
class default_1 extends Default_1.default {
    receivingSchema = {
        [ICondition_1.EventOpConditionalField.expectedArrivalDate]: this._validDateTimeOperations,
        [ICondition_1.EventOpConditionalField.confirmDate]: this._validDateTimeOperations,
        [ICondition_1.EventOpConditionalField.createDate]: this._validDateTimeOperations,
        [ICondition_1.EventOpConditionalField.landedCost]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.numberOfPalletized]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.primaryQty]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.secondaryQty]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.totalVolume]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.totalWeight]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.volume]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.numberOfPackagedUnits]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.lotNumber]: this._validTextOperations,
        [ICondition_1.EventOpConditionalField.qualifier]: this._validTextOperations,
        [ICondition_1.EventOpConditionalField.sku]: this._validTextOperations,
        //[EventOpConditionalField.class]: this._validTextOperations,
        [ICondition_1.EventOpConditionalField.capacityType]: this._validWMSTextoperations,
        [ICondition_1.EventOpConditionalField.muType]: this._validWMSTextoperations,
        [ICondition_1.EventOpConditionalField.transactionEntryType]: this._validWMSNumericOperations,
        [ICondition_1.EventOpConditionalField.itemClassification]: this._validWMSTextoperations,
        [ICondition_1.EventOpConditionalField.referenceNumber]: this._validTextOperations,
        [ICondition_1.EventOpConditionalField.fulfillmentTime]: this._validNumericOperations,
        [ICondition_1.EventOpConditionalField.poNumber]: this._validTextOperations,
    };
    validateAtomicCondition(condition, jsonPath) {
        const [operand1] = condition.operands;
        if (!operand1) {
            return [
                new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'operands', undefined, `${jsonPath}.operands[0]`),
            ];
        }
        if (operand1.opType !== ICondition_1.DataOperatorType.eventOperator) {
            return [
                new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.invalidValue, 'opType', operand1.opType, `${jsonPath}.operands[0]`),
            ];
        }
        switch (operand1.conditionalField) {
            case ICondition_1.EventOpConditionalField.createDate:
            case ICondition_1.EventOpConditionalField.confirmDate:
            case ICondition_1.EventOpConditionalField.expectedArrivalDate: {
                const { validOperations, valueType } = this._validDateTimeOperations;
                return this.validateComparison(condition, jsonPath, validOperations, valueType);
            }
            case ICondition_1.EventOpConditionalField.itemClassification:
            case ICondition_1.EventOpConditionalField.countryOfOrigin:
            case ICondition_1.EventOpConditionalField.hazardousMaterial:
            case ICondition_1.EventOpConditionalField.moveableUnit:
            case ICondition_1.EventOpConditionalField.hazardousMaterialFlag:
            case ICondition_1.EventOpConditionalField.capacityType:
            case ICondition_1.EventOpConditionalField.primaryUntis:
            case ICondition_1.EventOpConditionalField.secondaryUnits:
            case ICondition_1.EventOpConditionalField.muType:
            case ICondition_1.EventOpConditionalField.supplier: {
                const { validOperations, valueType } = this._validWMSTextoperations;
                return this.validateComparison(condition, jsonPath, validOperations, valueType);
            }
            case ICondition_1.EventOpConditionalField.transactionEntryType: {
                const { validOperations, valueType } = this._validWMSNumericOperations;
                return this.validateComparison(condition, jsonPath, validOperations, valueType);
            }
            case ICondition_1.EventOpConditionalField.landedCost:
            case ICondition_1.EventOpConditionalField.numberOfPalletized:
            case ICondition_1.EventOpConditionalField.primaryQty:
            case ICondition_1.EventOpConditionalField.secondaryQty:
            case ICondition_1.EventOpConditionalField.totalVolume:
            case ICondition_1.EventOpConditionalField.totalWeight:
            case ICondition_1.EventOpConditionalField.volume:
            case ICondition_1.EventOpConditionalField.numberOfPackagedUnits:
            case ICondition_1.EventOpConditionalField.fulfillmentTime: {
                const { validOperations, valueType } = this._validNumericOperations;
                return this.validateComparison(condition, jsonPath, validOperations, valueType);
            }
            case ICondition_1.EventOpConditionalField.lotNumber:
            case ICondition_1.EventOpConditionalField.qualifier:
            case ICondition_1.EventOpConditionalField.sku:
            case ICondition_1.EventOpConditionalField.class:
            case ICondition_1.EventOpConditionalField.referenceNumber:
            case ICondition_1.EventOpConditionalField.poNumber: {
                const { validOperations, valueType } = this._validTextOperations;
                return this.validateComparison(condition, jsonPath, validOperations, valueType);
            }
            default: {
                return [
                    new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.invalidValue, 'conditionalField', operand1.conditionalField, jsonPath),
                ];
            }
        }
    }
    requestNextValueSet(conditionalField) {
        if (conditionalField == undefined) {
            return Object.keys(this.receivingSchema);
        }
        const conditionalFieldValues = this.receivingSchema[conditionalField];
        if (conditionalFieldValues == undefined) {
            const validationError = new errors_1.Errors.ValidationError();
            validationError.addIssue('ICondition', errors_1.Errors.ValidationErrorCode.invalidValue, 'conditionalField', conditionalField);
            throw validationError;
        }
        return conditionalFieldValues;
    }
}
exports.default = default_1;
